import { factoryService, postJsonRequest } from '@chilecompra/react-kit/requests'
import { REACT_APP_API_BASE_BUYER_URL } from '../config/settings/environment'

/**
 * This function initiates the flow process for a user by making an API request.
 * It marks the beginning of the form submission process, where data is progressively
 * saved as the user completes each step of the form until the final submission. It returns an id that will need to be passed from step to step.
 */
export const initiateFlow = factoryService(({ token }) => {
  const body = {
    token
  }

  return postJsonRequest(`${REACT_APP_API_BASE_BUYER_URL}/v1/compradores/iniciarFlujo`, { body })
})

/**
 * This function registers the flow process for a user by making an API request.
 */
export const registerFlow = factoryService(({ flowId, flow }) => {
  const body = {
    idFlujo: flowId,
    flujo: flow
  }

  return postJsonRequest(`${REACT_APP_API_BASE_BUYER_URL}/v1/compradores/registrarFlujo`, { body })
})
